import React from 'react';
import {useHistory} from 'react-router-dom';
import {Box, Typography, IconButton} from '@material-ui/core';
import {KeyboardArrowLeft, KeyboardArrowRight} from '@material-ui/icons';
import {makeStyles, useMediaQuery} from '@material-ui/core';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation, Autoplay} from 'swiper';
import {getUrlFile} from '../../../modules/fileHandler';
// import PropTypes from 'prop-types';

import 'swiper/swiper.scss';

SwiperCore.use([Navigation, Autoplay]);

const useItemStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    background: 'transparent',
    textAlign: 'center',
    cursor: 'pointer',
  },
  img: {
    height: 45,
  },
}));

const SwiperItem = ({data}) => {
  const classes = useItemStyles();
  const history = useHistory();

  return (
    <Box
      className={classes.root}
      onClick={() => {
        history.push({
          pathname: '/b',
          search: `?refinementList[brand.name][0]=${data.name}`,
        });
      }}
    >
      <img src={getUrlFile(data.path_logo)} alt={data.name} className={classes.img} />
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '1.2rem',
    fontWeight: 600,
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  swiperCustom: {
    position: 'relative',
    marginTop: theme.spacing(2),
    '& .swiper-button-prev, & .swiper-button-next': {
      position: 'absolute',
      top: 0,
      right: 10,
      width: 40,
      height: 40,
      borderRadius: 500,
      backgroundColor: '#fff',
      boxShadow: '0px 0px 10px 0px rgba(189,189,189,1)',
      '&:after': {
        fontSize: 16,
        textTransform: 'none !important',
        letterSpacing: 0,
        fontVariant: 'initial',
        lineHeight: 1,
      },
    },
  },
  paginationButton: {
    border: `1px solid ${theme.palette.secondary.main}`,
    backgroundColor: theme.palette.secondary.main,
    marginRight: theme.spacing(1),
    color: 'white',
    '&:hover':{
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.primary.main,
    }
  },
}));

const Brands = ({title2, title, data = []}) => {
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);

  const xsScreen = useMediaQuery('(max-width:426px)');
  const classes = useStyles();

  if (!data.length) return <div />;
  return (
    <Box component="section">
      <div className={classes.swiperCustom}>
        <Box display="flex" justifyContent='space-between' mb={4}>
          <Box display="flex" alignItems="center">
            <Typography className={classes.title}>{title}</Typography>
          </Box>
          <Box display="flex" justifyContent="flex-end">
            <IconButton
              className={classes.paginationButton}
              color="secondary"
              variant="outlined"
              size="small"
              ref={navigationPrevRef}
            >
              <KeyboardArrowLeft fontSize="small" />
            </IconButton>
            <IconButton
              className={classes.paginationButton}
              color="secondary"
              variant="outlined"
              size="small"
              ref={navigationNextRef}
            >
              <KeyboardArrowRight fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Swiper
          key={xsScreen ? 'm' : 'd'}
          loop
          autoplay
          onSwiper={(swiper) => {
            setTimeout(() => {
              if (!swiper?.params) return;
              swiper.params.navigation.prevEl = navigationPrevRef.current;
              swiper.params.navigation.nextEl = navigationNextRef.current;
              swiper.navigation.destroy();
              swiper.navigation.init();
              swiper.navigation.update();
            }, 500);
          }}
          slidesPerView="auto"
          spaceBetween={30}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
        >
          {data.map((x, i) => (
            <SwiperSlide key={`swiper-cat-item-${i}`} style={{width: 'max-content'}}>
              <SwiperItem data={x} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Box>
  );
};

Brands.propTypes = {};

export default Brands;
